import { Platform } from "react-native";
import { SelectWeb } from "./select-web";
import { SelectNative } from "./select-native";
export const Select = Platform.OS === "web" ? SelectWeb : SelectNative;
